// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__nbGp5 > button {
  font-size: 0.9rem;
  padding: 0.18rem;
  margin: unset;
  min-width: unset; }
  .styles_container__nbGp5 > button svg {
    height: 0.72rem;
    width: 0.72rem;
    margin-bottom: 0.18rem;
    margin-left: -0.36rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/components/Text/TranslatableText/TranslationActions/styles.module.scss"],"names":[],"mappings":"AAAA;EAEI,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB,EAAA;EALpB;IAOM,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,qBAAqB,EAAA","sourcesContent":[".container {\n  & > button {\n    font-size: 0.9rem;\n    padding: 0.18rem;\n    margin: unset;\n    min-width: unset;\n    & svg {\n      height: 0.72rem;\n      width: 0.72rem;\n      margin-bottom: 0.18rem;\n      margin-left: -0.36rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__nbGp5`
};
export default ___CSS_LOADER_EXPORT___;
